import React from 'react';
import VisualizationDocPage from '@splunk/visualizations-shared/VisualizationDocPage';
import EncodingDoc from '@splunk/dashboard-visualizations/common/EncodingDoc';
import OptionsDoc from '@splunk/dashboard-visualizations/common/OptionsDoc';
import DocExample from '@splunk/react-docs/DocExample';

import ColorRangesCode from '!!raw-loader!./examples/ColorRangesExample';
import ColorGradientCode from '!!raw-loader!./examples/ColorGradientExample';
import LiteralSvgCode from '!!raw-loader!./examples/LiteralSvgExample';
import DataURISvgCode from '!!raw-loader!./examples/DataURISvgExample';

import ColorGradientExample from './examples/ColorGradientExample';
import ColorRangesExample from './examples/ColorRangesExample';
import LiteralSvgExample from './examples/LiteralSvgExample';
import DataURISvgExample from './examples/DataURISvgExample';

import doc from './definition';
import optionsSchema from '../optionsSchema';

// eslint-disable-next-line react/display-name
export default () => (
    <VisualizationDocPage
        title="ChoroplethSVG"
        description="This visualization has been upgraded in @splunk/visualizations/ChoroplethSvg and may be used in UDF."
        examplesSection={[
            <DocExample
                title="Loaded as a literal SVG"
                description="Campus map is loaded as a <svg></svg> string"
                key="LiteralSvgExample"
                code={LiteralSvgCode}
                example={LiteralSvgExample}
            />,
            <DocExample
                title="Loaded as a SVG data URI"
                description="Campus map is loaded as a data:image/svg+xml base64 binary"
                key="DataURISvgExample"
                code={DataURISvgCode}
                example={DataURISvgExample}
            />,
            <DocExample
                title="Encoding Format - Specify range values for fill color"
                description="In Campus Map, 'rangevalue' formatting is used to color buildings"
                key="ColorRangesExample"
                code={ColorRangesCode}
                example={ColorRangesExample}
            />,
            <DocExample
                title="Encoding format - Specify linear gradient for fill color"
                description="In Campus Map, 'gradient' formatting is used to color buildings"
                key="ColorGradientExample"
                code={ColorGradientCode}
                example={ColorGradientExample}
            />,
        ]}
        optionSection={<OptionsDoc options={optionsSchema} />}
        encodingSection={<EncodingDoc encoding={doc.encoding} />}
    />
);
